exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scan-shirt[data-v-598e734b] {\n  font-size: 90px !important;\n  height: 200px;\n}\n.btn-lg[data-v-598e734b] {\n  height: 50px;\n  font-size: 25px;\n}\n.loading[data-v-598e734b] {\n  font-size: 150px;\n  position: absolute;\n  top: 20%;\n  text-align: center;\n  width: 100%;\n  left: 0px;\n  right: 0px;\n  display: none;\n}\n.message[data-v-598e734b] {\n  font-size: 90px;\n}\n", ""]);

// exports
